<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Feed Back Process</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Feedback Process</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="calender ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Feedback Process 2020-21</h4>
            <a href="{{baseUrl}}/pdf/Feedback process-2020-21.pdf" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Feed Back Process</h4>
            <a href="{{baseUrl}}/pdf/feedback_process.pdf" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
